import { FaPlane } from "react-icons/fa";
import { Customized, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

export default function AltitudeGraph({ positions }) {

  const flightData = [...positions]
  .reverse()
  .map(p => ({
    Time: p.date,
    Altitude: p.altitudeFt
  }));
  const lastIndex = flightData.length - 1;

  const CustomDot = (props) => {
    const { cx, cy, index } = props;

    // Only show plane on last point
    if (index !== lastIndex) return null;

    return (
      <FaPlane
        style={{
          position: "absolute",
          transform: "translate(-50%, -50%) rotate(45deg)",
          fontSize: "15px",
          color: "#007bff",
        }}
        x={cx}
        y={cy}
      />
    );
  };

  return (
    <div style={{ width: "100%",height:"100px", position: "relative" }}>
      <ResponsiveContainer>
        <LineChart data={flightData}>
          <XAxis dataKey="Time" hide />
          <YAxis dataKey="Altitude" fontSize={'12px'} />
          <Tooltip labelStyle={{fontSize:"12px"}} />
          <Line
            type="monotone"
            dataKey="Altitude"
            stroke="#007bff"
            strokeWidth={2}
            dot={<CustomDot />}   // ✅ Custom dot only on last altitude
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
